import { FC, useState } from 'react';
import classNames from 'classnames';

import { i18n as I18n } from 'utils/i18n';

interface Props {
  title: string;
  collapsible: boolean;
  type: 'clinical' | 'non-clinical';
}

const TimeTable: FC<Props> = ({
  title,
  collapsible = true,
  type,
  children,
}) => {
  const [isTableOpen, setIsTableOpen] = useState(false);

  const tableClasses = classNames({
    'booking-times__times-table': true,
    [`booking-times__${type}-times-table`]: true,
    'booking-times__times-table--open': !!isTableOpen && collapsible,
    'booking-times__times-table--closed': !isTableOpen && collapsible,
  });

  const tableLinkClasses = classNames({
    'booking-times__table-link': true,
    [`booking-times__table-link--${type}`]: true,
  });

  const tableContainerClasses = classNames({
    'booking-times__table-container': true,
    'booking-times__table-container--open': !!isTableOpen && collapsible,
    'booking-times__table-container--closed': !isTableOpen && collapsible,
  });

  const handleTimeTableLinkClick = () => {
    setIsTableOpen(!isTableOpen);
  };

  const renderTimeTableLinkTitle = () => {
    return isTableOpen
      ? I18n.t('booking_times.close', {
          type: title,
        })
      : I18n.t('booking_times.open', {
          type: title,
        });
  };

  return (
    <>
      {collapsible && (
        <button
          className={tableLinkClasses}
          onClick={() => handleTimeTableLinkClick()}
          data-cy="timeTableLink"
          data-testid="timeTableLink"
        >
          {renderTimeTableLinkTitle()}
        </button>
      )}
      <div className={tableContainerClasses}>
        {collapsible && (
          <button
            className="booking-times__time-table-close-button"
            onClick={() => handleTimeTableLinkClick()}
            data-cy="timeTableCloseButton"
          >
            {I18n.t('modal.close')}
            <img
              src="/images/icons/accounts/close2.svg"
              alt={I18n.t('booking_times.close', { type: title })}
            />
          </button>
        )}
        <table className={tableClasses}>{children}</table>
      </div>
    </>
  );
};

export default TimeTable;
